import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import CategoryExplore from "./components/CategoryExplore";
import VideoLibrary from "./components/VideoLibrary";
import FeatureSection from "./components/FeatureSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

function JsonLd() {
  const data = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "吃瓜视频在线",
      url: "https://coolapples.cn/",
      logo: "https://coolapples.cn/logo.png",
      description:
        "吃瓜视频在线专注聚合热门娱乐八卦、社会热点与生活趣事视频，即点即看，无需安装。",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "吃瓜视频在线",
      url: "https://coolapples.cn/",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "吃瓜视频在线需要安装任何软件或插件吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "完全不需要。本站视频采用网页直连方式播放，无需下载客户端、无需安装任何插件，打开页面点击播放即可，真正做到即点即看。",
          },
        },
        {
          "@type": "Question",
          name: "手机和电脑上都能正常观看吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "可以的。网站针对手机端做了全面适配，竖屏、横屏都能流畅观看，同时完美兼容电脑、平板等设备，随时随地想看就看。",
          },
        },
        {
          "@type": "Question",
          name: "视频是免费的吗？内容多久更新一次？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "本站所有视频均免费观看，热门吃瓜内容每日实时更新，确保你能第一时间看到最新的话题和热门视频。",
          },
        },
        {
          "@type": "Question",
          name: "都有哪些类型的吃瓜视频？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "目前设有娱乐八卦、社会热点、明星现场、生活趣事、萌宠日常、街头采访六大分类，覆盖大家最常看的吃瓜内容。",
          },
        },
        {
          "@type": "Question",
          name: "播放卡顿或加载慢怎么办？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "本站视频采用极速缓冲技术，正常情况下可实现秒开。如果遇到卡顿，建议切换网络环境或刷新页面重试。",
          },
        },
        {
          "@type": "Question",
          name: "想看的视频没找到，或者有好的内容想推荐怎么办？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "欢迎通过页面底部的联系表单告诉我们，也可以直接留言推荐想看的内容，我们会认真整理并在后续更新中优先呈现。",
          },
        },
      ],
    },
  ];

  return (
    <>
      {data.map((d, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(d) }}
        />
      ))}
    </>
  );
}

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [activeCategory, setActiveCategory] = useState("全部");

  const scrollToVideos = () => {
    document.getElementById("videos")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSearch = (kw: string) => {
    setKeyword(kw);
    setActiveCategory("全部");
    scrollToVideos();
  };

  const handleCategorySelect = (cat: string) => {
    setActiveCategory(cat);
    setKeyword("");
    scrollToVideos();
  };

  return (
    <>
      <JsonLd />
      <Navbar />
      <main>
        <Hero onSearch={handleSearch} />
        <Trending />
        <CategoryExplore onSelect={handleCategorySelect} />
        <VideoLibrary
          keyword={keyword}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          onClearKeyword={() => setKeyword("")}
        />
        <FeatureSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}